import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (requireRole === "admin" && user.role !== "admin") {
    return <Navigate to="/app" replace />;
  }
  if (requireRole === "subscriber" && !["subscriber", "admin"].includes(user.role)) {
    return <Navigate to="/app/account" replace />;
  }
  return children;
}
